import { useEffect, useState } from "react";

// The gpuvm image servers listen only on gpuvm's localhost, so prompts never
// cross the network unencrypted. They are reached through SSH forwards:
//   deployed site  same-origin nginx proxy on passer.scpdx.net (HTTPS), which
//                  reaches gpuvm over the gpuvm-flux-tunnel SSH forward
//   local dev      the Mac's gpuvm SSH tunnel (net.gpuvm.museglimmer.tunnel)
//                  on 127.0.0.1:<port>
const GPUVM_SERVERS = {
  "http://195.230.127.226:8510": "/flux/gpu",    // FLUX.2-dev  (flux-api)
  "http://195.230.127.226:8511": "/flux1/gpu",   // FLUX.1-dev  (flux1-api)
};

export const imageApiBase = (apiUrl, port) => {
  const direct = `${apiUrl}:${port}`;
  const proxyPath = GPUVM_SERVERS[direct];
  if (!proxyPath) return direct;
  return window.location.protocol === "https:"
    ? `${window.location.origin}${proxyPath}`
    : `http://127.0.0.1:${port}`;
};

// The LoRA file the selected image server is configured with (from its
// status route), or null. Lets the pages show a strength slider only when
// there is a LoRA to weigh.
export const useServerLora = (apiUrl, port) => {
  const [loraFile, setLoraFile] = useState(null);
  useEffect(() => {
    setLoraFile(null);
    const base = imageApiBase(apiUrl, port);
    // From the https site an http server (e.g. Local 127.0.0.1) is blocked as
    // mixed content anyway; skip it rather than log errors.
    if (window.location.protocol === "https:" && base.startsWith("http:")) return undefined;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 8000);
    fetch(`${base}/`, { signal: controller.signal })
      .then((r) => r.json())
      .then((j) => setLoraFile(j.lora_file || null))
      .catch(() => {})   // server down or busy loading: just no slider
      .finally(() => clearTimeout(timer));
    return () => { controller.abort(); clearTimeout(timer); };
  }, [apiUrl, port]);
  return loraFile;
};
